import ngRedux from 'ng-redux'
import angular from 'angular'
import { Payment } from '../../../models/payment'
import { SalePaymentPopoverController as controller } from './sale-payment-popover.controller'
import template from './sale-payment-popover.html'

/**
 * Controller for the sale-payment component.
 *
 * @class SalePaymentController
 */
export class SalePaymentController {
  public payments: Payment[] = []

  constructor(
    private $element: JQLite,
    private vdPopover: $TSFixMe,
    private $ngRedux: ngRedux.INgRedux,
    private $scope: angular.IScope
  ) {
    'ngInject'

    const unsubscribe = this.$ngRedux.connect(state => {
      return {
        payments: state.currentSale.payments,
      }
    })(this)

    this.$scope.$on('$destroy', unsubscribe)
  }

  /**
   * Toggle the sale payment popover.
   *
   * @method togglePaymentPopover
   *
   * @param  {Event} event
   *         The DOM event for the click of the payment link that triggered the toggling of the popover
   */
  public togglePaymentPopover() {
    this.vdPopover.open({
      trigger: this.$element,
      template,
      controller,
      direction: 'left',
    })
  }
}
